import { render, staticRenderFns } from "./es-extend.vue?vue&type=template&id=0cf37070&scoped=true&"
import script from "./es-extend.vue?vue&type=script&lang=js&"
export * from "./es-extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf37070",
  null
  
)

export default component.exports